import { render } from "./LinkAndUnlinkCompayFromDepotDiscountGroupsModal.html?vue&type=template&id=380cd81a&scoped=true"
import script from "./LinkAndUnlinkCompayFromDepotDiscountGroupsModal.js?vue&type=script&lang=js"
export * from "./LinkAndUnlinkCompayFromDepotDiscountGroupsModal.js?vue&type=script&lang=js"

import "./LinkAndUnlinkCompayFromDepotDiscountGroupsModal.css?vue&type=style&index=0&id=380cd81a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380cd81a"]])

export default __exports__